import { renderDisplayCode } from './display-code.js';
import { runPairing } from './flow.js';

function renderClassicForm(rootEl, { onSubmit, onShowDisplay }) {
  rootEl.innerHTML = `
    <div class="pairing pairing--classic">
      <h1>Accoppia il TV</h1>
      <p class="pairing__hint">Inserisci il codice mostrato sul backoffice</p>
      <form id="pair-form">
        <input id="pair-code" type="text" maxlength="6" inputmode="text" autofocus />
        <button type="submit">Accoppia</button>
      </form>
      <p id="pair-error" class="error" style="display: none;"></p>
      <a href="#" id="pair-show-display" class="pairing-toggle-link">Mostra codice sul TV</a>
    </div>
  `;

  const form = rootEl.querySelector('#pair-form');
  const input = rootEl.querySelector('#pair-code');
  const error = rootEl.querySelector('#pair-error');
  const showDisplayLink = rootEl.querySelector('#pair-show-display');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    error.style.display = 'none';
    error.textContent = '';
    const code = input.value.trim().toUpperCase();
    if (!code) return;
    try {
      await onSubmit(code);
    } catch (err) {
      error.textContent = err.message ?? 'Errore accoppiamento';
      error.style.display = 'block';
    }
  });

  showDisplayLink.addEventListener('click', (e) => {
    e.preventDefault();
    onShowDisplay();
  });
}

/**
 * Default pairing screen: inverted code + QR. Toggle to classic BO-code form.
 */
export function renderPairingUI(rootEl) {
  let cleanup = null;

  async function showDisplay() {
    if (cleanup) cleanup();
    rootEl.innerHTML =
      '<div class="pairing"><p class="pairing__hint">Generazione codice…</p></div>';

    cleanup = await renderDisplayCode(rootEl);

    const container = rootEl.querySelector('.pairing--display');
    if (!container) return;

    const link = document.createElement('a');
    link.href = '#';
    link.id = 'pair-show-classic';
    link.className = 'pairing-toggle-link';
    link.textContent = 'Ho un codice dal backoffice';
    link.addEventListener('click', (e) => {
      e.preventDefault();
      showClassic();
    });
    container.appendChild(link);
  }

  function showClassic() {
    if (cleanup) cleanup();
    cleanup = null;
    renderClassicForm(rootEl, {
      onSubmit: async (code) => {
        await runPairing(code);
        window.location.reload();
      },
      onShowDisplay: showDisplay,
    });
  }

  showDisplay();
}
